import { getProductPrice } from "@helpers/products/getProductPrice";

import type { Item } from "@typings/product/item";
import type { ProductConfiguration } from "@typings/product/product";

// Helper function to find options from variant name
const variantNameToOptions = (
  item: Item,
  variantName: string,
  offerId: number
): { [optionId: number]: number } => {
  const variant = item.variants.find((v) => v.name === variantName && v.offerId === offerId);

  if (!variant) {
    return Object.fromEntries(item.options.map((o) => [o.id, o.values[0].id]));
  }

  const parts = variantName.split(" / ");
  const options: { [optionId: number]: number } = {};

  for (const part of parts) {
    for (const option of item.options) {
      const matchingValue = option.values.find((value) => value.name === part.trim());

      if (matchingValue) {
        options[option.id] = matchingValue.id;
        break;
      }
    }
  }

  for (const option of item.options) {
    if (!options[option.id]) {
      options[option.id] = option.values[0].id;
    }
  }

  return options;
};

export default (
  item: Item,
  upsell?: { orderId: number },
  isFbw?: boolean,
  variantName?: string
): ProductConfiguration => {
  const isPromotion = !!(upsell || isFbw);
  const offer =
    item.price <= 0
      ? item.offers.find((o) => o.name === "One Time Sale")
      : item.offers.find((o) => o.name === "Monthly Subscription") || item.offers[0];

  let options: { [optionId: number]: number };

  if (variantName) {
    options = variantNameToOptions(item, variantName, offer.id);
  } else {
    options =
      isPromotion && promotionOptions[item.id]
        ? promotionOptions[item.id]
        : Object.fromEntries(item.options.map((o) => [o.id, o.values[0].id]));
  }

  return {
    ...getProductPrice(item, offer, options, isPromotion, variantName),
    offer,
    isFbw,
    upsell,
    options,
    quantity: 1,
    variant: variantName,
  };
};

const promotionOptions: { [itemId: number]: Record<number, number> } = {};
